import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import Select from 'react-select';

// react-select menüsünün modalın üzerinde görünmesini sağlayan stil objesi
const customSelectStylesForModal = {
    menu: (provided) => ({ ...provided, zIndex: 9999 }),
    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
};

const MultiLanguageInput = ({ value = {}, onChange, allLanguages = [], onSelectedLangsChange, selectedLangs = [], placeholderKey }) => {
    const { t } = useTranslation();
    
    const [activeLang, setActiveLang] = useState(selectedLangs[0]?.value || '');

    useEffect(() => {
        if (selectedLangs.length > 0 && !selectedLangs.some(lang => lang.value === activeLang)) {
            setActiveLang(selectedLangs[0].value);
        } else if (selectedLangs.length === 0 && activeLang) {
            setActiveLang('');
        }
    }, [selectedLangs, activeLang]);

    const handleInputChange = (e) => {
        const { value: inputValue } = e.target;
        onChange({ ...value, [activeLang]: inputValue });
    };

    return (
        <div className="multilang-input-container">
            <div className="multilang-header">
                <Select
                    isMulti
                    options={allLanguages}
                    value={selectedLangs}
                    onChange={onSelectedLangsChange}
                    placeholder={t('select_languages_for_content')}
                    className="lang-multi-select"
                    classNamePrefix="react-select"
                    // z-index sorununu çözen props
                    menuPortalTarget={document.body}
                    styles={customSelectStylesForModal}
                />
            </div>
            {activeLang && selectedLangs.length > 0 && (
                <>
                    <div className="multilang-tabs">
                        {selectedLangs.map(lang => (
                            <button 
                                key={lang.value}
                                type="button"
                                className={`lang-tab-btn ${activeLang === lang.value ? 'active' : ''}`}
                                onClick={() => setActiveLang(lang.value)}
                            >
                                {lang.label}
                            </button>
                        ))}
                    </div>
                    <textarea
                        className="multilang-textarea"
                        key={activeLang}
                        value={value[activeLang] || ''}
                        onChange={handleInputChange}
                        placeholder={t(placeholderKey, { lang: activeLang.toUpperCase() })}
                    />
                </>
            )}
        </div>
    );
};

export default MultiLanguageInput;